/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VisitCanStartAt
 */
export interface VisitCanStartAt {
}

/**
 * Check if a given object implements the VisitCanStartAt interface.
 */
export function instanceOfVisitCanStartAt(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function VisitCanStartAtFromJSON(json: any): VisitCanStartAt {
    return VisitCanStartAtFromJSONTyped(json, false);
}

export function VisitCanStartAtFromJSONTyped(json: any, ignoreDiscriminator: boolean): VisitCanStartAt {
    return json;
}

export function VisitCanStartAtToJSON(value?: VisitCanStartAt | null): any {
    return value;
}

